import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { TranslateService } from '@ngx-translate/core';
import {
    AbsenteeismTotalizerData,
    AbsenteeismTotalizerQueryInput,
} from "../../core/interfaces/absenteeism-filter-input";
import { Subject, throwError } from 'rxjs';
import { catchError, finalize, takeUntil } from "rxjs/operators";
import { SStatsCardAbsenteeismService } from './s-stats-card-absenteeism.service';
import { AccidentType } from '../../core/enums/accident-type';
@Component({
    selector: "s-stats-card-absenteeism",
    templateUrl: "./s-stats-card-absenteeism.component.html",
    styleUrls: ["./s-stats-card-absenteeism.component.scss"]
})
export class SStatsCardAbsenteeismComponent implements AfterViewInit, OnDestroy {

    @Input() domain: string;
    @Input() service: string;
    @Input() accidentType: AccidentType;
    @Input() employeeSearch: string;
    @Output() totalizerChangeEvent = new EventEmitter<AbsenteeismTotalizerData >();

    totalizerCountLoading = true;
    totalizerCountError = false;

    private readonly _filter: AbsenteeismTotalizerQueryInput = {};
    private readonly _ngUnsubscribe = new Subject();
    private _absenteeismIndex: string | number;
    private _totalWorkedHours: string | number;
    private _totalAbsenceHours: string | number;

    constructor(
        private readonly _translateService: TranslateService,
        private readonly route: ActivatedRoute,
        private readonly _sStatsCardWorkAccidentServiceservice: SStatsCardAbsenteeismService
    ) {}
    ngOnDestroy(): void {
        this._ngUnsubscribe.next();
        this._ngUnsubscribe.complete();
    }
    @Input()
    public set ticket(ticket) {
        this._filter.ticket = ticket;
        if (ticket && this.domain && this.service) {
            this.updateCounters();
        }
    }
    ngAfterViewInit() {
        if (!this._filter?.ticket) {
            this.updateCounters();
        }
    }

    private genericGet(value: string | number): string {
        if (typeof value === 'string') {
            return value;
        }
        return value && value >= 1 ? value.toString() : '0';
    }

    private setFields() {
        this._filter.domain = this.domain;
        this._filter.service = this.getService();
    }

    public updateCounters() {
        this.totalizerCountLoading = true;
        const messageError = this._translateService.instant('hcm.analytics_sst.error_fetching_count');
        this.setFields();
        this._sStatsCardWorkAccidentServiceservice.getAbsenteeismTotalizerQuery(this._filter)
            .pipe(
                takeUntil(this._ngUnsubscribe),
                finalize(() => {
                    const totalizerChangeDto: AbsenteeismTotalizerData = {
                        totalAbsenceHours: this.totalAbsenceHours,
                        totalWorkedHours: this.totalWorkedHours,
                        absenteeismIndex: this.absenteeismIndex,
                    };
                    this.totalizerChangeEvent.next(totalizerChangeDto);
                })
            )
            .pipe(catchError(error => {
                this.totalAbsenceHours = messageError;
                this.totalWorkedHours = messageError;
                this.absenteeismIndex = messageError;
                this.totalizerCountLoading = false;
                this.totalizerCountError = true;
                return throwError(error);
            }))
            .subscribe((data: any) => {
                this.totalAbsenceHours = data.result.totalAbsenceHours;
                this.totalWorkedHours = data.result.totalWorkedHours;
                this.absenteeismIndex = data.result.absenteeismIndex;

                this.totalizerCountError = false;
                this.totalizerCountLoading = false;
            });
    }

    public getAbsenteeismIndex(absenteeismIndex) {
        if (!absenteeismIndex) {
            return this.genericGet(absenteeismIndex);
        } else {
            return typeof absenteeismIndex === "number" ?
                `${absenteeismIndex?.toString().replace(".", ",")}%` : absenteeismIndex;
        }
    }

    get absenteeismIndex() {
        return this._absenteeismIndex;
    }

    set absenteeismIndex(value: string | number) {
        this._absenteeismIndex = value;
    }

    get totalWorkedHours() {
        return this.genericGet(this._totalWorkedHours);
    }

    set totalWorkedHours(value: string | number) {
        this._totalWorkedHours = value;
    }

    get totalAbsenceHours() {
        return this.genericGet(this._totalAbsenceHours);
    }

    set totalAbsenceHours(value: string | number) {
        this._totalAbsenceHours = value;
    }

    /**
     * Esse funÃ§Ã£o foi criada pra chavear o contexto do filtro avanÃ§ado.
     * Quando vier do analytics-frontend, deve passar o serviÃ§o analytics, quando abrir direto na tela
     * do analytics-payroll, deve passar o serviÃ§o do analytics_sst
     * o parametro "ticket" sÃ³ vai vir na rota, atrÃ¡ves do analytics-frontend
     * @private
     */
    private getService() {
        let service = this.service;
        if (this.route?.snapshot?.queryParams["ticket"]) {
            service = "analytics";
        }
        return service;
    }
}
